/**
 * 按「从哪个域名打开的」决定连哪台后端。
 *
 * ★ 用户要的:从 freshvalley.nz 打开就连 delivery-nz-api.freshvalley.nz,
 *   从 freshvalley.co.nz 打开就连 delivery-nz-api.freshvalley.co.nz。
 *   两个域名各走各的,同一份构建两边都能用 —— 不用为每个域名单独打包。
 *
 * ★ 在运行时看 `location.hostname`,不是构建期变量:
 *   Cloudflare Pages 一个项目只有一份构建,却可以挂好几个域名。
 *
 * ★ 认不出来的域名(pages.dev 预览地址、localhost、App 里的 capacitor://)返回 null,
 *   调用方再退回 VITE_API_BASE / 相对路径。
 */
const HOST_RULES: ReadonlyArray<{ suffix: string; api: string }> = [
  // ★ co.nz 必须排在 .nz 前面 —— 「freshvalley.co.nz」不以「freshvalley.nz」结尾,
  //   但规则多了以后顺序错一个就会张冠李戴,按「更长的先比」写死
  { suffix: 'freshvalley.co.nz', api: 'https://delivery-nz-api.freshvalley.co.nz/api/v1' },
  { suffix: 'freshvalley.nz', api: 'https://delivery-nz-api.freshvalley.nz/api/v1' },
];

export function apiBaseForHost(hostname: string): string | null {
  const h = hostname.toLowerCase().replace(/\.$/, '');
  for (const r of HOST_RULES) {
    if (h === r.suffix || h.endsWith(`.${r.suffix}`)) return r.api;
  }
  return null;
}
